import type { TFunction } from "i18next";
import type { FusionItemDef } from "~/components/dock/FusionMenu";

const resolveFulfillReportsMenuItems = (
	fulfillReportItems: FusionItemDef[],
	fulfillReportsError: boolean,
	fulfillReportsLoading: boolean,
	t: TFunction<"common">
): FusionItemDef[] => {
	if (fulfillReportsLoading) {
		return [{ icon: "hourglass_empty", label: t("dock.pages.reports.loading") }];
	}
	if (fulfillReportsError) {
		return [{ icon: "error_outline", label: t("dock.pages.reports.loadError"), path: "/fulfill/reports" }];
	}
	return fulfillReportItems.length > 0
		? fulfillReportItems
		: [{ icon: "info", label: t("dock.pages.reports.noAppTaggedReports"), path: "/reports" }];
};

export default resolveFulfillReportsMenuItems;
